import { render, staticRenderFns } from "./SettingsFullTeamSize.vue?vue&type=template&id=59dc12a8&"
import script from "./SettingsFullTeamSize.vue?vue&type=script&lang=js&"
export * from "./SettingsFullTeamSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports